import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '@/App.css';
import HomePage from '@/pages/HomePage';
import EligibilityTest from '@/pages/EligibilityTest';
// import ServicePage from '@/pages/ServicePage';
const PacAirEau1Euro = React.lazy(() => import("./pages/PacAirEau1Euro"));
const AidesAnnahCee = React.lazy(() => import("./pages/AidesAnnahCee"));
import PompesAChaleurPage from '@/pages/PompesAChaleurPage';
import EauChaudeSanitairePage from '@/pages/EauChaudeSanitairePage';
import IsolationPage from '@/pages/IsolationPage';
import VentilationPage from '@/pages/VentilationPage';
import ContactPage from '@/pages/ContactPage';
import LegalMentions from '@/pages/LegalMentions';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import Layout from '@/components/Layout';
import ScrollToTopOnRouteChange from '@/components/ScrollToTopOnRouteChange';
const TemoignagesClients = React.lazy(() => import("./pages/TemoignagesClients"));
const ZoneIntervention = React.lazy(() => import("./pages/ZoneIntervention"));
import DeptParis75 from "@/pages/DeptParis75";
import DeptSeineEtMarne77 from "@/pages/DeptSeineEtMarne77";
import DeptYvelines78 from "@/pages/DeptYvelines78";
import DeptEssonne91 from "@/pages/DeptEssonne91";
import DeptHautsDeSeine92 from "@/pages/DeptHautsDeSeine92";
import DeptSeineSaintDenis93 from "@/pages/DeptSeineSaintDenis93";
import DeptValDeMarne94 from "@/pages/DeptValDeMarne94";
import DeptValOise95 from "@/pages/DeptValOise95";
import DeptOise60 from "@/pages/DeptOise60";
import DeptEure27 from "@/pages/DeptEure27";
import DeptEureEtLoir28 from "@/pages/DeptEureEtLoir28";
import DeptLoiret45 from "@/pages/DeptLoiret45";
import DeptYonne89 from "@/pages/DeptYonne89";
import DeptAube10 from "@/pages/DeptAube10";
import DeptAisne02 from "@/pages/DeptAisne02";
import DeptSomme80 from "@/pages/DeptSomme80";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTopOnRouteChange />
      <Layout>
          <React.Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="text-xl">Chargement...</div></div>}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/test-eligibilite" element={<EligibilityTest />} />
          
          {/* Nouvelles pages groupées */}
          <Route path="/services/pompes-a-chaleur" element={<PompesAChaleurPage />} />
          <Route path="/services/eau-chaude-sanitaire" element={<EauChaudeSanitairePage />} />
          <Route path="/services/isolation" element={<IsolationPage />} />
          <Route path="/services/ventilation" element={<VentilationPage />} />
            <Route path="/pac-air-eau-1-euro" element={<PacAirEau1Euro />} />
            <Route path="/aides-anah-cee" element={<AidesAnnahCee />} />
            <Route path="/temoignages-clients" element={<TemoignagesClients />} />
            <Route path="/zone-intervention" element={<ZoneIntervention />} />
            <Route path="/installation-pac-paris-75" element={<DeptParis75 />} />
            <Route path="/installation-pac-seine-et-marne-77" element={<DeptSeineEtMarne77 />} />
            <Route path="/pompe-chaleur-yvelines-78" element={<DeptYvelines78 />} />
            <Route path="/pompe-chaleur-essonne-91" element={<DeptEssonne91 />} />
            <Route path="/pac-air-eau-hauts-de-seine-92" element={<DeptHautsDeSeine92 />} />
            <Route path="/installation-pac-seine-saint-denis-93" element={<DeptSeineSaintDenis93 />} />
            <Route path="/pac-air-eau-val-de-marne-94" element={<DeptValDeMarne94 />} />
            <Route path="/installation-pac-val-oise-95" element={<DeptValOise95 />} />
            <Route path="/pompe-chaleur-oise-60" element={<DeptOise60 />} />
            <Route path="/pac-air-eau-eure-27" element={<DeptEure27 />} />
            <Route path="/installation-pac-eure-et-loir-28" element={<DeptEureEtLoir28 />} />
            <Route path="/pompe-chaleur-loiret-45" element={<DeptLoiret45 />} />
            <Route path="/pac-air-eau-yonne-89" element={<DeptYonne89 />} />
            <Route path="/installation-pac-aube-10" element={<DeptAube10 />} />
            <Route path="/pompe-chaleur-aisne-02" element={<DeptAisne02 />} />
            <Route path="/pac-air-eau-somme-80" element={<DeptSomme80 />} />
          
          {/* Anciennes routes pour compatibilité - redirigent vers les sections */}
          {/* <Route path="/services/:slug" element={<ServicePage />} /> */}
          
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/mentions-legales" element={<LegalMentions />} />
          <Route path="/politique-confidentialite" element={<PrivacyPolicy />} />
        </Routes>
          </React.Suspense>
      </Layout>
    </BrowserRouter>
  );
}

export default App;